import {AnyAction} from 'redux';
import Types from '../../../actions/Types';

import {mergeResponse, QueryState} from '../Response';

import HelpCategory from '../../../../domain/entities/writer/HelpCategory';
import PaginatedResult from '../../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexWriterHelpCategoriesSuccess: {
      const result = action.payload as PaginatedResult<HelpCategory>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
